import { createActionGroup, props } from '@ngrx/store';
import { CategoriesResponse, LoadRewardsRequest } from '../../models/request.model';

export const CategoriesActions = createActionGroup({
  source: 'Categories',
  events: {
    'Load Categories': props<LoadRewardsRequest>(),
    'Load Categories Success': props<{ data: CategoriesResponse }>(),
    'Load Categories Failure': props<{ error: string }>(),
  },
});